import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useTypedSelector } from '../hooks/useTypedSelector'
import styles from './css/LegalNotice.module.css'

interface Props {
	mode?: 'login' | 'payment'
}

const LegalNotice: FC<Props> = ({ mode = 'payment' }) => {
	const russian = useTypedSelector(state => state.lang.current) === 0
	const prefix = mode === 'login'
		? (russian ? 'Входя, вы принимаете ' : 'By signing in, you accept the ')
		: (russian ? 'Оплачивая доступ, вы принимаете ' : 'By paying for access, you accept the ')

	return (
		<p className={styles.notice}>
			{prefix}<Link to='/tos'>{russian ? 'соглашение' : 'terms of use'}</Link>.{' '}
			<Link to='/privacy'>{russian ? 'Как обрабатываются данные' : 'How we process your data'}</Link>.
		</p>
	)
}

export default LegalNotice
